<mat-sidenav-container [style.visibility]="hideProtectedContent() ? 'hidden' : null" [attr.inert]="hideProtectedContent() ? '' : null" class="h-100" (backdropClick)="closeBasketNav()">
            <mat-sidenav fixedInViewport #basketNav mode="over" position="end" class="w-20">
                <basket-sidenav
                    [supplierBaskets]="supplierBaskets$ | async"
                    [basket]="basket$ | async"
                    (basketItemDeleted)="deleteItem($event)"
                ></basket-sidenav>
            </mat-sidenav>
            <mat-sidenav-content #content id="scroll-container">
                <router-outlet></router-outlet>
            </mat-sidenav-content>
        </mat-sidenav-container>
